// extracted by mini-css-extract-plugin
export var column = "PresessionPage-module--column--ab80a";
export var content = "PresessionPage-module--content--ce979";
export var contentFullWidth = "PresessionPage-module--contentFullWidth--5a088";
export var page = "PresessionPage-module--page--aaccd";